import { render, staticRenderFns } from "./CompanyMultiRestaurantTabCreditTopups.vue?vue&type=template&id=79434400"
import script from "./CompanyMultiRestaurantTabCreditTopups.vue?vue&type=script&lang=js"
export * from "./CompanyMultiRestaurantTabCreditTopups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports